import { all, call, put, takeEvery, take } from 'redux-saga/effects';
import Actions from './actions';
import Constants from '../../constants';
import FilesAPI from '../../Lib/Api/files';
import { handleError } from '../../Lib/Utils/saga-utils';

const { PublicFiles } = Constants;
const {
  getFilesError,
  getFilesSuccess,
  uploadFileError,
  uploadFileProgress,
  uploadFileSuccess,
} = Actions;

export function* getPublicFiles(getType) {
  try {
    const response = yield call(FilesAPI.getPublicFiles, getType);
    yield put(getFilesSuccess(response));
  } catch (err) {
    yield handleError(getFilesError, err);
  }
}

export function* uploadPublicFile({ file }) {
  const chan = yield call(FilesAPI.uploadPublicFile, file);

  try {
    while (true) {
      const event = yield take(chan);
      if (event.progressEvent) {
        yield put(uploadFileProgress(event.progressEvent, file));
      } else if (event.data) {
        yield put(uploadFileSuccess(event.data));
      }
    }
  } catch (err) {
    yield handleError(uploadFileError, err);
  }
}

function* publicFilesSaga() {
  yield all([
    yield takeEvery(PublicFiles.GET_FILES, getPublicFiles),
    yield takeEvery(PublicFiles.UPLOAD_FILE, uploadPublicFile),
  ]);
}

export default publicFilesSaga;
